'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/12/2.
                                          */

// import {addToPreselection, productAddedInfoAllClear, buyImmediately, clearBuyImmediatelyInfo} from 'redux/modules/preselection';
// import {submitGroupBuying} from 'redux/modules/groupBuying';
// import {add, clearAdd} from 'redux/modules/attentionArtwork';
// import {add as shopAdd, clearAdd as shopClearAdd} from 'redux/modules/attentionShop';
// import {add as designerAdd, clearAdd as designerClearAdd} from 'redux/modules/attentionDesigner';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HeaderPreview = require('../Header/HeaderPreview');

var _HeaderPreview2 = _interopRequireDefault(_HeaderPreview);

var _reactRedux = require('react-redux');

var _productDetail = require('redux/modules/productDetail');

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { push } from 'react-router-redux';
// import { Link } from 'react-router';

var ProductDetailQuickPreview = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var params = _ref.params;

    if (!(0, _productDetail.isQuickLoaded)(getState())) {
      return dispatch((0, _productDetail.loadQuick)(params.productId));
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    quickData: state.productDetail.quickData
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ProductDetailQuickPreview, _Component);

  function ProductDetailQuickPreview() {
    (0, _classCallCheck3.default)(this, ProductDetailQuickPreview);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ProductDetailQuickPreview).call(this));

    _this.state = {
      showOrHideBuyBlock: ''
    };
    return _this;
  }

  (0, _createClass3.default)(ProductDetailQuickPreview, [{
    key: 'showOrHideBuyBlock',
    value: function showOrHideBuyBlock() {
      var showOrHideBuyBlock = this.state.showOrHideBuyBlock;

      if (showOrHideBuyBlock) {
        this.setState({
          showOrHideBuyBlock: false
        });
      } else {
        this.setState({
          showOrHideBuyBlock: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var showOrHideBuyBlock = this.state.showOrHideBuyBlock;
      var quickData = this.props.quickData;
      // console.log(quickdata);

      var resultDiv = _react2.default.createElement('div', null);
      if (quickData) {
        var productDetailFirstPage = quickData.productDetailFirstPage;

        var price = 0;
        var styles = require('../ProductDetails/ProductDetails.scss');
        var buyClassName = styles.acrt + ' ' + styles.tanstion;
        var priceClassName = styles.yx_ea + ' ' + styles.tanstion;
        if (showOrHideBuyBlock === true) {
          buyClassName = styles.acrt + ' ' + styles.tanstion + ' ' + styles.tranBuyGroupF;
          priceClassName = styles.yx_ea + ' ' + styles.tanstion + ' ' + styles.tranBuyGroupFd;
        } else if (showOrHideBuyBlock === false) {
          buyClassName = styles.acrt + ' ' + styles.tanstion;
          priceClassName = styles.yx_ea + ' ' + styles.tanstion;
        }

        var anchors = ['productDetailFirstPage'];
        var array = [{
          text: '首页',
          href: 'productDetailFirstPage',
          type: 'nav',
          icon: 'icon01'
        }];

        var contentDiv = [_react2.default.createElement(
          _components.FullPageSection,
          { key: '0', className: styles.goeasySection },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(_HeaderPreview2.default, null)
          ),
          productDetailFirstPage instanceof Array ? _react2.default.createElement(
            'div',
            { className: styles.firstFullPageItem },
            _react2.default.createElement(_components.ProductInfoFirstCarousel, { first: true,
              images: productDetailFirstPage })
          ) : '',
          _react2.default.createElement(
            'div',
            { className: styles.xuanfu, style: { display: 'none' } },
            _react2.default.createElement(
              'article',
              { className: buyClassName },
              _react2.default.createElement(
                'ul',
                { className: styles.zbutn },
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement('img', {
                      src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn5.png', alt: '' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement('img', {
                      src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn4.png', alt: '' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement('img', {
                      src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn3.png', alt: '' })
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement('img', {
                      src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn1.png', alt: '' })
                  )
                )
              )
            ),
            _react2.default.createElement(
              'span',
              { onClick: this.showOrHideBuyBlock.bind(this), className: priceClassName },
              _react2.default.createElement(
                'p',
                {
                  className: styles.txt },
                '¥ ' + price
              )
            )
          )
        )];

        var options = {
          sectionClassName: 'section',
          anchors: anchors,
          scrollBar: false,
          activeClass: styles.active,
          navigation: false,
          verticalAlign: false,
          sectionPaddingTop: '0',
          sectionPaddingLeft: '0',
          sectionPaddingRight: '0',
          sectionPaddingBottom: '0'
        };

        resultDiv = _react2.default.createElement(
          'div',
          { className: styles.component },
          _react2.default.createElement(
            _components.FullPageHeader,
            null,
            _react2.default.createElement(_components.GoeasyFullPageHeader, { content: array, headerActiveIndex: 0 })
          ),
          _react2.default.createElement(
            _components.FullPageSectionsContainer,
            (0, _extends3.default)({ className: 'container' }, options),
            contentDiv
          )
        );
      }
      return resultDiv;
    }
  }]);
  return ProductDetailQuickPreview;
}(_react.Component), _class2.propTypes = {
  quickData: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ProductDetailQuickPreview;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ProductDetailQuickPreview/ProductDetailQuickPreview.js
 ** module id = 1526
 ** module chunks = 0
 **/